import httpClient from './httpClient'

const END_POINT = '/seller'

const RingTreeTargetRequestAPI = {

  /**
   * Create a new Ring Tree Target request for a specific offer registration
   * @param {string} accountId - The seller account ID
   * @param {string} registrationId - The seller offer registration ID
   * @param {RingTreeTargetRequest.CreateRingTreeTargetApiRequest} requestData - Ring Tree Target request details
   * @returns {Promise<RingTreeTargetRequest.CreateRingTreeTargetResponse>} Promise resolving to creation result
   */
  async createRequest(accountId, registrationId, requestData) {
    return await httpClient.post(`${END_POINT}/${accountId}/rtt-requests/offer-registrations/${registrationId}`, requestData)
  },

  /**
   * Get all Ring Tree Target requests for the specified account
   * @param {string} accountId - The seller account ID
   * @returns {Promise<RingTreeTargetRequest.GetAllRequestsResponse>} Promise resolving to array of requests
   */
  async getAllRequests(accountId) {
    return await httpClient.get(`${END_POINT}/${accountId}/rtt-requests`)
  },

  /**
   * Get detailed information for a specific Ring Tree Target request
   * @param {string} accountId - The seller account ID
   * @param {string} requestId - The specific request ID
   * @returns {Promise<RingTreeTargetRequest.GetRequestDetailsResponse>} Promise resolving to request details
   */
  async getRequestDetails(accountId, requestId) {
    return await httpClient.get(`${END_POINT}/${accountId}/rtt-requests/${requestId}`)
  }
}

export default RingTreeTargetRequestAPI